/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterIdEntry } from '../../models/work-center-id-entry';

export interface DeleteWhiteWasteAssignment$Params {
  mountedMaterialId: number;
      body: WorkCenterIdEntry
}

export function deleteWhiteWasteAssignment(http: HttpClient, rootUrl: string, params: DeleteWhiteWasteAssignment$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, deleteWhiteWasteAssignment.PATH, 'post');
  if (params) {
    rb.path('mountedMaterialId', params.mountedMaterialId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

deleteWhiteWasteAssignment.PATH = '/api/v1/PrimaryMaterial/{mountedMaterialId}/DeleteWhiteWasteFromMountedMaterial';
